export const toSnakeCase = (str: string) => {
  return str
    .replace(/-/g, '_') // Convert kebab-case to snake_case
    .replace(/([a-z])([A-Z])/g, '$1_$2') // Convert camelCase to snake_case (only between lowercase and uppercase)
    .toLowerCase()
    .replace(/^_/, '') // Remove leading underscore if present
    .replace(/_+/g, '_') // Replace multiple consecutive underscores with a single one
}
